import React, { FunctionComponent, ReactNode } from 'react';
import styled from '@emotion/styled';

const SUPPORT_FORM_URL = 'https://help.nsknox.net/migration/knowledge/contact-us';

// <Trans> maps the translation's <1> to the child at position 1, and the {' '} fillers prettier inserts when it
// wraps a long JSX line count as children too. Keeping the attributes here lets the call site stay
// `text <SupportFormLink>…</SupportFormLink> text` on one line.
const SupportFormLink: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  return (
    <Anchor
      id='vldt-for-supp-support-form'
      data-testid='vldt-for-supp-support-form'
      href={SUPPORT_FORM_URL}
      target='_blank'
      rel='noreferrer'
    >
      {children}
    </Anchor>
  );
};

export default SupportFormLink;

// antd's global a:hover rules win over a plain emotion class, hence the !important and the explicit hover colour.
const Anchor = styled.a`
  font-weight: bold;
  color: var(--accent-blue-600);
  text-decoration: underline !important;

  &:hover {
    color: var(--accent-blue-600);
  }
`;
